// 九宫格云台UI配置
export const ptzConfig = [{
        need: true,
        style: 'transform: rotate(45deg)',
        command: 'LEFT_UP'
    },
    {
        need: true,
        style: 'transform: rotate(90deg)',
        command: 'UP'
    },
    {
        need: true,
        style: 'transform: rotate(135deg)',
        command: 'RIGHT_UP'
    },
    {
        need: true,
        style: 'transform: rotate(0deg)',
        command: 'LEFT'
    },
    {
        need: false,
        style: 'transform: rotate(0deg)',
        command: 'GOTO_PRESET'
    },
    {
        need: true,
        style: 'transform: rotate(180deg)',
        command: 'RIGHT'
    },
    {
        need: true,
        style: 'transform: rotate(315deg)',
        command: 'LEFT_DOWN'
    },
    {
        need: true,
        style: 'transform: rotate(275deg)',
        command: 'DOWN'
    },
    {
        need: true,
        style: 'transform: rotate(225deg)',
        command: 'RIGHT_DOWN'
    }
]

// 九宫格云台UI配置 new
export const PTZ_CONFIG = [{
		need: true,
		style: 'transform: rotate(45deg)',
		command: 'upleft'
	},
	{
		need: true,
		style: 'transform: rotate(90deg)',
		command: 'up'
	},
	{
		need: true,
		style: 'transform: rotate(135deg)',
		command: 'upright'
	},
	{
		need: true,
		style: 'transform: rotate(0deg)',
		command: 'left'
	},
	{
		need: false,
		style: 'transform: rotate(0deg)',
		command: 'GOTO_PRESET'
	},
	{
		need: true,
		style: 'transform: rotate(180deg)',
		command: 'right'
	},
	{
		need: true,
		style: 'transform: rotate(315deg)',
		command: 'downleft'
	},
	{
		need: true,
		style: 'transform: rotate(270deg)',
		command: 'down'
	},
	{
		need: true,
		style: 'transform: rotate(225deg)',
		command: 'downright'
	}
]

// 明景布控球映射方法
export function MJMapCommand(command) {
    switch (command) {
        case 'ZOOM_OUT':
            return 12;
        case 'ZOOM_IN':
            return 11;
        case 'FOCUS_FAR':
            return 13;
        case 'FOCUS_NEAR':
            return 14;
        case 'IRIS_ENLARGE':
            return 15;
        case 'IRIS_REDUCE':
            return 16;
        case 'UP':
            return 21;
        case 'DOWN':
            return 22;
        case 'LEFT':
            return 23;
        case 'RIGHT':
            return 24;
        case 'LEFT_UP':
            return 25;
        case 'RIGHT_UP':
            return 26;
        case 'LEFT_DOWN':
            return 27;
        case 'RIGHT_DOWN':
            return 28;
        case 'GOTO_PRESET':
            return 42;
        default:
            break;
    }
}

export const VIDEO_PROTOCOL = {
    rtsp: 'rtsp',
    hls: 'hls',
    flv: 'flv',
    ws: 'ws'
}

// 视频来源枚举类型
export const SOURCE_ENUM = {
  hikvision: 'hikvision',
  dahua8: 'dahua8',
  dahuaicc: 'dahuaicc',
  dahua8900: 'dahua8900',
  myeyes: 'myeyes',
  icvs: 'icvs',
  minking: 'minking',
  ay: 'ay',
  zlk: 'zlk',
  livenvr: 'livenvr',
  uniview: 'uniview',
  DHplayer: 'DHplayer'
}

// 支持云台的平台
export const SUPPORT_PTZS = ['hikvision', 'icvs', 'dh', 'myeyes', 'ay','dahuaicc']

// 视频来源枚举类型
export const VIDEO_MODE_ENUM = {
    hkPlayer: '3',
    h5: '0',
    vlc: '2',
    iVMSHK: '12'
}

// 使用新版获取视频url接口
export const USE_NEW_PREVIEW_VIDEO_SOURCE = ['icvs', 'dahuaicc', 'myeyes', 'minking', 'beidou', 'livenvr', 'zlk', 'dahua8900','tianyi']

// 支持获取视频GPS接口
export const USE_GETGPS_VIDEO_SOURCE = ['icvs', 'minking']

export const URLS = {
  getHKH5VideoUrl: '/api/iot/video/getVideoUrl', // 获取海康H5视频URL 如果项目要求延时性在改用海康WSURL播放 已废弃
  NYPreview: '/api/iot/video/ny/preview', // 南耀预览接口
  NYKeepAlive: '/api/iot/video/ny/keepAlive', // 南耀视频保活接口
  ISVMSHKPreview: '/api/iot/video/hk', // ISVMS海康平台取流接口
  NYClose: '/api/iot/video/ny/close', // 南耀视频关闭
  getHKConfig: '/api/iot/video/getHkConfig', // 获取海康配置
  getGPSUrl: '/api/iot/media/v1/video/getGPS/latest', // 获取GPS信息
  getVideoUrl: '/api/iot/video', // 获取单个视频信息
  voiceUrl: '/api/iot/video/getVoice', // 明景声音配置
  listRecords: '/api/iot/video/listRecords', // 通用视频回放接口
  getRecordUri: '/api/iot/video/record/getUri', // 通用获取视频回放列表
  myeyesVideoRecordsList: '/api/iot/video/myeyesVideoRecordsList', // MYEYES回放列表接口
  myeyesVideoCallbackUrl: '/api/iot/video/myeyesVideoCallbackUrl', // MYEYES回放地址
  dahuaIccVideoRecordsList: '/api/iot/video/dahuaIccVideoRecordsList', // DahuaICC回放列表
  dahuaIccVideoCallbackUrl: '/api/iot/video/dahuaIccVideoCallbackUrl', // DahuaICC回放地址
  mjGetUri: '/api/iot/video/record/getUri', // 明景回放配置
  yunTaiCtr: '/api/iot/media/v1/video/yunTaiCtr', // 云台控制APi
  previewUrl: '/api/iot/media/v1/video/preview', // 新版视频预览接口
  ayPreviewUrl: '/api/iot/media/v1/channel/preview/urls', // 安元获取视频预览URL地址
  ayYunTaiCtlUrl: '/api/iot/media/v1/channel/ptzControl/', // 安元云台控制URL
  ayVideoRecordUrl: '/api/iot/media/v1/channel/records', // 安元视频回放URL
  ayVideoRecordPlayUrl: '/api/iot/media/v1/channel/playback', // 安元视频回放播放URL
  startGBPreviewUrl: '/api/iot/gb/start', // 开始特殊的GB拉流接口 针对URL携带参数处理
  startRecordUrl: '/api/iot/video/startRecord', // 开始录制视频
  stopRecordUrl: '/api/iot/video/stopRecord', // 停止录制视频
  rtspRepackagingUrl: '/api/iot/media/v1/streamProxy/rtspProxy', // RTSP转码协议
  getVideoByCodeUrl: '/api/iot/media/v1/videoByCode', // 根据Code获取单个信息接口 可定制 为跨容器播放准备
  //   getPluginConfigUrl: '/api/iot/plugin/config', // 根据Code获取视频插件配置
  getPluginConfigUrl: '/api/iot/video/pluginDetail', // 根据Code获取视频插件配置-宇视
  getStartVoice: '/api/iot/media/v1/channel/video/audio/start', // 开启设备对讲
  getStopVoice: '/api/iot/media/v1/channel/video/audio/stop', // 停止设备对讲
  getWebsocket: '/api/iot/media/v1/channel/video/audio/deviceWs' // 获取websocket地址
}

export const HOST = `http://10.0.26.175:8089`

export const IOT_SPECIAL_FLAG = "iotVideoFlag"

export const VP_ERROR_CONFIG = {
    errorMaxCount: 10, // 错误重试阈值
}

export const VP_ERROR = {
  GET_STREAM_FAIL: '获取视频详细信息失败！请检查配置！',
  CODE_NOTFOUND: '检索不到对应视频编码，请检查数据！',
  AY_ZLK_REPACKAGE_FAIL: '浏览器转码服务调用失败！请检查！',
  HK_REPACKAGE_FAIL: '海康转码服务调用失败！请检查！',
  AY_GET_STREAM_FAIL: '获取视频流失败！请检查！',
  HK_HLS_FAIL: '海康取hls流失败！'
}

export const VIDEO_PREVIEW_KEYS = {
    univiewToken: 'uniview_token'
}
// // 判断是否是清新互联布控球
// export const IS_ICVS = function(code) {
//     if (code && code.indexOf('icvs') > -1) {
//         return true;
//     }
//     return false
// }

// // 判断是否是清新互联布控球
// export const IS_ICVS = function(code) {
//     if (code && code.indexOf('icvs') > -1) {
//         return true;
//     }
//     return false
// }